/**
 * Mapa de iconos de botón por id. Mismos ids que el backoffice (buttonIconLibrary.js)
 * para que los iconos coincidan entre editor y web.
 */
import {
	IconArrowRight,
	IconArrowLeft,
	IconArrowUp,
	IconArrowDown,
	IconPlayerPlay,
	IconPhoto,
	IconVideo,
	IconCamera,
	IconCheck,
	IconX,
	IconPlus,
	IconMinus,
	IconTrash,
	IconEdit,
	IconCopy,
	IconArrowBackUp,
	IconArrowForwardUp,
	IconBulb,
	IconStar,
	IconLock,
	IconLockOpen,
	IconFlag,
	IconTrophy,
	IconBookmark,
	IconHeart,
	IconSearch,
	IconHome,
	IconMapPin,
	IconMenu2,
	IconDots,
	IconDotsVertical,
	IconInfoCircle,
	IconHelpCircle,
	IconAlertTriangle,
	IconChevronDown,
	IconChevronUp,
	IconSend,
	IconShare,
	IconLink,
	IconExternalLink,
	IconMail,
	IconPhone,
	IconBell,
	IconSettings,
	IconEye,
	IconRefresh,
	IconDownload,
	IconCalendar,
	IconThumbUp,
	IconLogin,
	IconLogout,
	IconCategory,
	IconLayoutGrid,
	IconClipboardList,
	IconThumbDown,
	IconThumbDownFilled,
	IconUsers,
	IconUsersGroup,
	IconFriends,
	IconClock,
	IconHourglassEmpty,
	IconDatabase,
	IconKey,
	IconMessageCircle,
	IconChartBar,
	IconBolt,
	IconWorld,
	IconChartHistogram,
	IconPointer,
	IconHandClick,
	IconHandStop,
	IconMouse,
	IconFingerprint,
	IconPlayerPause,
	IconPlayerStop,
	IconVolume,
	IconVolumeOff,
	IconMicrophone,
	IconHeadphones,
	IconZoomIn,
	IconZoomOut,
	IconMaximize,
	IconChecks,
	IconChevronsRight,
	IconCompass,
	IconCurrentLocation,
	IconFocus2,
	IconSwipe,
	IconCircleDot,
	IconEyeOff,
	IconRepeat,
} from "@tabler/icons-react";

const MAP = {
	arrowRight: IconArrowRight,
	arrowForward: IconArrowRight,
	arrowBack: IconArrowLeft,
	arrowLeft: IconArrowLeft,
	arrowUp: IconArrowUp,
	arrowDown: IconArrowDown,
	chevronRight: IconArrowRight,
	chevronLeft: IconArrowLeft,
	doubleArrow: IconChevronsRight,
	touch: IconHandClick,
	touchOutlined: IconPointer,
	hand: IconHandStop,
	mouse: IconMouse,
	gesture: IconSwipe,
	fingerprint: IconFingerprint,
	focus: IconFocus2,
	select: IconCircleDot,
	play: IconPlayerPlay,
	playArrow: IconPlayerPlay,
	pause: IconPlayerPause,
	stop: IconPlayerStop,
	replay: IconRepeat,
	image: IconPhoto,
	video: IconVideo,
	camera: IconCamera,
	volume: IconVolume,
	volumeOff: IconVolumeOff,
	mic: IconMicrophone,
	headset: IconHeadphones,
	check: IconCheck,
	doneAll: IconChecks,
	close: IconX,
	add: IconPlus,
	remove: IconMinus,
	delete: IconTrash,
	edit: IconEdit,
	copy: IconCopy,
	undo: IconArrowBackUp,
	redo: IconArrowForwardUp,
	lightbulb: IconBulb,
	star: IconStar,
	lock: IconLock,
	lockOpen: IconLockOpen,
	flag: IconFlag,
	trophy: IconTrophy,
	bookmark: IconBookmark,
	favorite: IconHeart,
	search: IconSearch,
	home: IconHome,
	location: IconMapPin,
	explore: IconCompass,
	myLocation: IconCurrentLocation,
	menu: IconMenu2,
	moreHoriz: IconDots,
	moreVert: IconDotsVertical,
	zoomIn: IconZoomIn,
	zoomOut: IconZoomOut,
	fullscreen: IconMaximize,
	info: IconInfoCircle,
	help: IconHelpCircle,
	warning: IconAlertTriangle,
	expandMore: IconChevronDown,
	expandLess: IconChevronUp,
	send: IconSend,
	share: IconShare,
	link: IconLink,
	openInNew: IconExternalLink,
	mail: IconMail,
	phone: IconPhone,
	notifications: IconBell,
	settings: IconSettings,
	visibility: IconEye,
	visibilityOff: IconEyeOff,
	refresh: IconRefresh,
	download: IconDownload,
	schedule: IconCalendar,
	thumbUp: IconThumbUp,
	thumbDown: IconThumbDown,
	thumbDownAlt: IconThumbDownFilled,
	community: IconUsers,
	group: IconUsersGroup,
	friends: IconFriends,
	timer: IconClock,
	hourglass: IconHourglassEmpty,
	storage: IconDatabase,
	vpnKey: IconKey,
	forum: IconMessageCircle,
	barChart: IconChartBar,
	flashOn: IconBolt,
	public: IconWorld,
	equalizer: IconChartHistogram,
	login: IconLogin,
	logout: IconLogout,
	category: IconCategory,
	viewModule: IconLayoutGrid,
	assignment: IconClipboardList,
	mapPin: IconMapPin,
	"map-pin": IconMapPin,
	puzzle: IconLayoutGrid,
};

export function getButtonIconComponent(iconId) {
	if (!iconId || typeof iconId !== "string") return null;
	const id = String(iconId).trim();
	return MAP[id] || null;
}

const MATERIAL_ICON_LIGATURES = {
	arrowRight: "arrow_forward",
	arrowForward: "arrow_forward",
	arrowBack: "arrow_back",
	arrowLeft: "arrow_back",
	arrowUp: "arrow_upward",
	arrowDown: "arrow_downward",
	chevronRight: "arrow_forward",
	chevronLeft: "arrow_back",
	play: "play_arrow",
	playArrow: "play_arrow",
	image: "image",
	video: "video_library",
	camera: "photo_camera",
	check: "check",
	close: "close",
	add: "add",
	remove: "remove",
	delete: "delete",
	edit: "edit",
	copy: "content_copy",
	undo: "undo",
	redo: "redo",
	lightbulb: "emoji_objects",
	star: "star_border",
	lock: "lock",
	lockOpen: "lock_open",
	flag: "flag",
	trophy: "emoji_events",
	bookmark: "bookmark_border",
	favorite: "favorite_border",
	search: "search",
	home: "home",
	location: "location_on",
	menu: "menu",
	moreHoriz: "more_horiz",
	moreVert: "more_vert",
	info: "info",
	help: "help_outline",
	warning: "warning",
	expandMore: "expand_more",
	expandLess: "expand_less",
	send: "send",
	share: "share",
	link: "link",
	openInNew: "open_in_new",
	mail: "mail_outline",
	phone: "phone",
	notifications: "notifications_none",
	settings: "settings",
	visibility: "visibility",
	refresh: "refresh",
	download: "download",
	schedule: "schedule",
	thumbUp: "thumb_up",
	thumbDown: "thumb_down",
	thumbDownAlt: "thumb_down_alt",
	community: "people_outline",
	group: "group",
	friends: "emoji_people",
	timer: "timer",
	hourglass: "hourglass_empty",
	storage: "storage",
	vpnKey: "vpn_key",
	forum: "forum",
	barChart: "bar_chart",
	flashOn: "flash_on",
	public: "public",
	equalizer: "equalizer",
	login: "login",
	logout: "logout",
	category: "category",
	viewModule: "view_module",
	assignment: "assignment",
	doubleArrow: "double_arrow",
	touch: "touch_app",
	touchOutlined: "touch_app",
	hand: "pan_tool",
	mouse: "mouse",
	gesture: "gesture",
	fingerprint: "fingerprint",
	focus: "filter_center_focus",
	select: "radio_button_checked",
	pause: "pause",
	stop: "stop",
	replay: "replay",
	volume: "volume_up",
	volumeOff: "volume_off",
	mic: "mic_none",
	headset: "headset",
	doneAll: "done_all",
	explore: "explore",
	myLocation: "my_location",
	zoomIn: "zoom_in",
	zoomOut: "zoom_out",
	fullscreen: "fullscreen",
	visibilityOff: "visibility_off",
	mapPin: "location_on",
	"map-pin": "location_on",
	puzzle: "view_module",
};

export function getButtonIconLigature(iconId) {
	if (!iconId || typeof iconId !== "string") return null;
	const id = String(iconId).trim();
	return MATERIAL_ICON_LIGATURES[id] || null;
}

export default MAP;
